const aux = (props) => {
    //window.scrollTo(0, 0);

    return props.children;
};

export default aux;